import { Grid, Typography } from '@mui/material'
import React from 'react'

const GridItems = ({title, value}) => {
    return (
        <Grid item xs={6} md={3}>
            <Typography variant="h5">
                {title}
            </Typography>
            <Typography>
                {value}
            </Typography>
        </Grid>
    )
}

export default GridItems
